import React from "react";
import "./MulaNote.css";
import arrow from "../../../assets/arrow-left-top.png";

const MulaNote = () => {
  return (
    <div className="mulanote__section">
      <p>
        Note that digital currencies can be volatile and buying them can be
        risky. While MULA will always have utilities, the price of MULA
        denominated in fiat currency may change, and you could lose significant
        value.
      </p>

      <div className="mulanote__section__arrow">
        <img src={arrow} alt="" />
      </div>
    </div>
  );
};

export default MulaNote;
